// extracted by css-extract-rspack-plugin
export default {"clickArea":"clickArea-16rFB"};